import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import '../static/css/SignUpSuccess.css';
import logo from '../static/images/images/a-logo-transperent.png';
import AppStoreButtons from './AppStoreButtons';
import EventBonusOffer from './EventBonusOffer';

class SignUpSuccess extends Component {
    constructor() {
        super();
        const userJson = localStorage.getItem('user');
        const user = userJson ? JSON.parse(userJson) : null;
        const token = localStorage.getItem('token');
        this.state = {
            firstName: (user && user.first_name) || 'Friend',
            email: (user && user.email) || '',
            hasSession: !!(token && user),
            cameFromSignup: sessionStorage.getItem('from_signup') === '1',
        };
    }

    componentDidMount() {
        // One-time view: consume the signal so a refresh / back-navigation / direct visit
        // lands on /home instead of re-showing this page.
        if (this.state.cameFromSignup) {
            sessionStorage.removeItem('from_signup');
        }
    }

    render() {
        if (!this.state.hasSession) {
            return <Navigate to="/signin" replace />;
        }
        if (!this.state.cameFromSignup) {
            return <Navigate to="/home" replace />;
        }
        const { firstName, email } = this.state;
        return (
            <div className="signup-success-container">
                <div className="animates-logo-container">
                    <Link to="/"><img className="animates-logo hover" style={{width: "125px"}} src={logo} alt="" /></Link>
                </div>
                <div className="signup-success-card">
                    <h1 className="signup-success-title" style={{fontFamily: "'Chelsea Market', cursive"}}>
                        Welcome to AniMates,<br />{firstName}! <span className="signup-success-emoji">🎉</span>
                    </h1>
                    <p className="signup-success-message">
                        Your account is created. AniMates lives in our mobile apps — that's where you'll set up your profile, edit your info, and start joining events. The web view is a quick read-only summary of your account.
                    </p>
                    <p className="signup-success-message signup-success-message-cta">
                        Download the AniMates app to get started:
                    </p>
                    <AppStoreButtons variant="signup" />
                    {email && (
                        <p className="signup-success-verify-note">
                            We sent a verification link to <span className="signup-success-email">{email}</span> — verify your email to earn your verified badge.
                        </p>
                    )}
                    <EventBonusOffer />
                    <Link to="/create-event-opportunity" className="signup-success-button">Create an Event</Link>
                    <Link to="/home" className="signup-success-button signup-success-button-secondary">Continue to web view</Link>
                    <p style={{fontSize: "10px", color: "#888", marginTop: "16px", textAlign: "center"}}>This page is shown only once — please don't refresh or use the back button.</p>
                </div>
                <p className="signup-success-footer">© 2026 AniMates. All rights reserved.</p>
            </div>
        );
    }
}

export default SignUpSuccess;
